import { render, staticRenderFns } from "./forRent.vue?vue&type=template&id=f63fd2aa&scoped=true"
import script from "./forRent.vue?vue&type=script&lang=js"
export * from "./forRent.vue?vue&type=script&lang=js"
import style0 from "./forRent.vue?vue&type=style&index=0&id=f63fd2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63fd2aa",
  null
  
)

export default component.exports